<!-- COMMENT HISTORY -->
<ul>
  @for (comment of commentHistory; track comment) {
    <li class="comment-history">
      @if (commentEditionAllowed) {
        <span (click)="onClickDeleteComment(comment)"><i class="fa fa-remove remove-comment-icon" aria-hidden="true"></i></span>
      }
      <label for="comment-{{comment.uid}}">{{comment.datetime}} - {{comment.user}} - {{comment.type | translate}}</label>
      @if (commentEditionAllowed && !comment.editMode) {
        <span (click)="onClickEditComment(comment)"><i class="fa fa-edit edit-comment-icon" ></i></span>
      }
      @if (commentEditionAllowed && comment.editMode) {
        <span (click)="onClickCancelEditComment(comment)"><i class="fa fa-cancel cancel-comment-icon" aria-hidden="true"></i></span>
      }
      @if (commentEditionAllowed && comment.editMode) {
        <span (click)="onClickConfirmEditComment(comment)"><i class="fa fa-check confirm-comment-icon" aria-hidden="true"></i></span>
      }
      @if (!comment.editMode) {
        <p>{{comment.comment}}</p>
      }
      @if (comment.editMode && !comment.loading) {
        <textarea class="form-control" id="comment-{{comment.uid}}" [(ngModel)]="comment.comment"></textarea>
      }
      @if (comment.editMode && comment.loading) {
        <div class="spinner-container"><i class="fa-solid fa-spinner fa-pulse default-spinner"></i></div>
      }
    </li>
  }
</ul>
<!-- NEW COMMENT -->
<div class="form-group">
  <label id="newCommentLabel" for="newComment">{{'deliveries.form.newComment' | translate}}</label>
  @if (!newCommentLoading) {
    <textarea class="form-control" id="newComment" [(ngModel)]="newComment" (input)="onChangeNewComment()"></textarea>
  }
  @if (newCommentLoading) {
    <span><i class="fa-solid fa-spinner fa-pulse default-spinner"></i></span>
  }
  <div class="mt-20 text-right">
    <button [disabled]="newComment == ''" type="button" class="btn btn--primary" (click)="onClickNewComment()">{{'deliveries.form.newComment' | translate}}</button>
  </div>
</div>